import {SxStyles} from "../../types";
import theme from "../../theme";

export const ControlPanelHeaderModal: SxStyles = {
    onSaveDataModal: {
        '&.save-modal .modal-wrapper': {
            width: `calc(${theme.palette.propVars?.index} * 17.3)`,
            height: `calc(${theme.palette.propVars?.index} * 8.6)`,
            border: `2px solid #65B3CF`,
        },
    },
}